import styled from "@emotion/styled";

import { Box } from "@/components/layout/flexbox";
import { breakpoints } from "@/components/layout/Media";

export const ViewTimeSessionBoxStyled = styled(Box)`
  position: relative;

  .loading-overlay {
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.08);
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border-radius: 8px;
  }

  .sts-row {
    justify-content: flex-start;
    flex-direction: row;
    flex-wrap: wrap;

    .calendar-wrapper {
      flex: 2;
      margin-right: 60px;

      .calendar-ratio {
        width: 100%;
        padding-top: 100%;
        position: relative;

        .inner-ration {
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;

          .rc_root {
            width: 100%;
            height: 100%;

            .rc {
              width: 100% !important;
              height: 100% !important;
            }
          }
        }
      }
    }

    .timeslot-wrapper {
      flex-direction: column;
      position: relative;
      flex: 1;

      .bottom-linear-overlay {
        background: linear-gradient(
          180deg,
          rgba(255, 255, 255, 0) 0%,
          #ffffff 78.65%
        );
        position: absolute;
        height: 48px;
        bottom: 0;
        left: 0;
        right: 16px;
        z-index: 1;
      }

      .timeslot-content {
        position: relative;
        overflow: auto;
        flex: 1 1 100px;
        padding-right: 32px;
        padding-bottom: 32px;

        .timezone-wrapper {
          position: sticky;
          top: 0;
          z-index: 1;
          background-color: #ffffff;
        }
      }
    }
  }

  .date-label {
    font-weight: 600;
    font-size: 20px;
    line-height: 40px;
  }

  *::-webkit-scrollbar {
    width: 16px;
  }

  *::-webkit-scrollbar-thumb {
    background-color: #767676ed;
    background-clip: padding-box;
    border: 4px solid transparent;
    border-radius: 8px;
  }

  @media screen and (max-width: ${breakpoints.sm - 1}px) {
    margin: 0 0 16px 0;
  }

  @media screen and (max-width: ${breakpoints.ml - 1}px) {
    .sts-row {
      .timeslot-wrapper {
        .timeslot-content {
          .timezone-wrapper {
            min-width: 240px;
          }
        }
      }
    }
  }

  @media screen and (max-width: ${breakpoints.lg - 1}px) {
    .sts-row {
      flex-direction: column;
      flex-wrap: nowrap;

      .calendar-wrapper {
        margin-right: 0;
        margin-bottom: 32px;
      }

      .timeslot-wrapper {
        .timeslot-content {
          overflow: unset;
          padding: 0;

          .timezone-wrapper {
            width: 100%;
          }

          .timeslot-list {
            width: 100%;

            .timeslots-selector {
              display: flex;
              flex-direction: row;
              flex-wrap: wrap;
              margin: 0 -12px;

              .timeslot-item {
                width: 50%;
                padding: 2px 12px;
              }
            }
          }
        }

        .bottom-linear-overlay {
          display: none;
        }
      }
    }
  }
`;
